import { Button, Col, Form, Input, Row, Select, message } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useContext, useState } from "react";
import BeforeTableHeader from "../../layouts/beforeTableHeader";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import { useForm } from "antd/lib/form/Form";
import { useNavigate } from "react-router-dom";
import {
  getVFormsListThunk,
  saveFormsThunk,
} from "../../../store/thunks/surveyThunk";
import { useDispatch } from "react-redux";

const AddForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const [showLoader, setShowLoader] = useState(true);
  const [form] = useForm();
  const [list, setList] = useState([]);
  const [errors, setErrors] = useState([]);

  const lIUId = secureLocalStorage.getItem("lIUId");

  const { Option } = Select;
  function isValidJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (error) {
      return false;
    }
  }
  const onFinish = async (values) => {
    const jsonString = values?.formContent;
    if (!isValidJSON(jsonString)) {
      message.error("Content is not valid json");
    } else {
      const payload = {
        source: "form",
        formName: values?.formName.replaceAll(" ", "-"),
        formDisplayName: values?.formDisplayName,
        formType: values?.formType ? values?.formType : "feedback",
        formContent: values?.formContent,
        formDefaultReplyTo: values?.formDefaultReplyTo,
        formDefaultSender: values?.formDefaultSender,
        formDefaultWatchers: values?.formDefaultWatchers,
        status: "ACTIVE",
        createdBy: lIUId,
        createdAt: new Date(
          new Date().getTime() - new Date().getTimezoneOffset() * 60000,
        )
          .toISOString()
          .slice(0, 19)
          .replace("T", " "),
      };

      await dispatch(saveFormsThunk(payload))
        .unwrap()
        .then((response) => {
          setErrors([]);
          message.success("Form created successfully");
          // Reset form fields
          form.resetFields();
          navigate("/forms");
        })
        .catch((error) => {
          if (error.data && error.data.message) {
            setErrors(error.data.message);
          } else {
            message.error("An error occurred while creating the Form");
          }
        });
    }
  };

  /*begin::getVFormList will fetch list of forms*/
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const getVFormsList = async (page = 1, pageSize = 10) => {
    try {
      setGlobalState({ ...globalState, list: [] });

      const payload = { page, pageSize };

      const response = await dispatch(getVFormsListThunk(payload));
      const { forms, totalCount } = response;
      const temp = forms.map((dataList, index) => ({
        key: dataList._id,
        id: index + 1,
        name: dataList.name,
        permission: dataList.permission,
        created_at: moment(dataList.createdAt).format("DD-MM-YY HH:mm A"),
      }));
      setList(temp);
      setGlobalState({ ...globalState, list: temp });
      setShowLoader(false);
      setPagination({
        ...pagination,
        current: page,
        pageSize,
        total: totalCount,
      });
    } catch (error) {
      console.error("Error fetching forms list:", error);
    }
  };
  /*end::Add new form*/
  {
    /*For Watchers dropdown values in state*/
  }
  const childrenList = [];
  const [selectedValues, setSelectedValues] = useState([]);
  const handleChange = (value) => {
    setSelectedValues(value);
  };
  return (
    <div className="all-content">
      <BeforeTableHeader list={list && list.length} href="" />
      <div className="all-table-holder border-0">
        <Form
          name="basic"
          onFinish={onFinish}
          initialValues={{ remember: true }}
          layout="vertical"
          id="antdformstyle"
          form={form}
          className="add-custom-form"
        >
          <Row className="add-custom-form-body pb-16" gutter={[12, 12]}>
            <Col xs={24} sm={12} md={12} lg={8} xl={8}>
              <Form.Item
                className="m-0"
                label="Name"
                name="formName"
                rules={[
                  { required: true, message: "Please enter the form name!" },
                ]}
              >
                <Input placeholder="Enter name" className="w-100" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={8} xl={8}>
              <Form.Item
                className="m-0"
                label="Display Name"
                name="formDisplayName"
                rules={[
                  {
                    required: true,
                    message: "Please enter the form display name!",
                  },
                ]}
              >
                <Input placeholder="Enter display name" className="w-100" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={8} xl={8}>
              <Form.Item
                className="m-0"
                label="Type"
                name="formType"
                rules={[
                  {
                    required: true,
                    message: "Please enter the form type!",
                  },
                ]}
              >
                <Input placeholder="Enter type" className="w-100" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={8} xl={8}>
              <Form.Item
                className="m-0"
                label="Reply To"
                name="formDefaultReplyTo"
                rules={[
                  {
                    required: true,
                    message: "Please enter the form default reply to!",
                  },
                ]}
              >
                <Input placeholder="Enter reply to" className="w-100" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={8} xl={8}>
              <Form.Item
                className="m-0"
                label="Sender"
                name="formDefaultSender"
                rules={[
                  {
                    required: true,
                    message: "Please enter the form default sender!",
                  },
                ]}
              >
                <Input
                  placeholder="Enter the form default sender!"
                  className="w-100"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={8} xl={8}>
              <Form.Item
                className="m-0"
                label="Watchers"
                name="formDefaultWatchers"
                rules={[
                  {
                    required: true,
                    message: "Please enter the form default watchers!",
                  },
                ]}
              >
                <Select
                  showSearch
                  allowClear
                  mode="tags"
                  size={"large"}
                  placeholder="Enter Email ID's"
                  value={selectedValues}
                  onChange={handleChange}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      ?.toLowerCase()
                      .includes(input?.toLowerCase())
                  }
                >
                  {childrenList}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                className="m-0"
                label="Content"
                name="formContent"
                rules={[
                  {
                    required: true,
                    message: "Please enter the form content!",
                  },
                ]}
                validateStatus={
                  errors && errors["formContent"] ? "error" : undefined
                }
                help={
                  errors && errors["formContent"]
                    ? errors["formContent"]
                    : undefined
                }
              >
                <TextArea placeholder="Enter content" className="w-100" />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={12} md={12} lg={8} xl={8}>
              <Form.Item
                label="Status"
                name="status"
                rules={[{ required: true, message: "Please select a status!" }]}
              >
                <Select>
                  <Option value="ACTIVE">ACTIVE</Option>
                  <Option value="INACTIVE">IN-ACTIVE</Option>
                </Select>
              </Form.Item>
            </Col> */}
          </Row>
          <Row className="add-custom-form-footer pb-16 mt-4" gutter={[12, 12]}>
            <div className="d-flex justify-content-end w-100 modalBtns">
              <Button
                type="primary"
                htmlType="reset"
                className="defaultBtn defaultGreyBtn"
              >
                Clear
              </Button>
              <Button type="primary" htmlType="submit" className="defaultBtn">
                Submit
              </Button>
            </div>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default AddForm;
